var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#2a2e3b","strokeLinecap":"round","strokeLinejoin":"round","transform":"matrix(0 -1 1 0 2.5 16.5)"},[React.createElement("path",{"d":"m2 .5h8c1.1045695 0 2 .8954305 2 2v10c0 1.1045695-.8954305 2-2 2h-8c-1.1045695 0-2-.8954305-2-2v-10c0-1.1045695.8954305-2 2-2z","key":0}),React.createElement("path",{"d":"m2 6 5 3 5-3","transform":"matrix(0 1 -1 0 14.5 .5)","key":1})]));
}

Mail.defaultProps = {"height":"28","viewBox":"0 0 21 21","width":"28"};

module.exports = Mail;

Mail.default = Mail;
